import React from "react";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import { Box } from "@mui/material";

const Team = () => {
  const { pathname } = useLocation();
  const { organization } = useOutletContext();
  if (!organization) {
    return;
  }
  const creatingNew =
    pathname === `/organizations/${organization.id}/team/invite`;

  return (
    <Box>
      <Outlet context={{ organization, creatingNew }} />
    </Box>
  );
};

export default Team;
